import React, { } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import FormatCurrency from 'components/Common/FormatCurrency'
import SolidExclamationCircleIcon from 'components/Luxkit/Icons/solid/SolidExclamationCircleIcon'
import Pill from 'components/Luxkit/Pill'
import Caption from 'components/Luxkit/Typography/Caption'
import Group from 'components/utils/Group'
import TextButton from 'components/Luxkit/Button/TextButton'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import { ValueWrapper } from 'components/Common/OfferPricing/styles'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import CruiseDiscountTermsAndConditions from 'components/Cruises/CruiseDiscountTermsAndConditions'
import { getCruiseOfferPriceVariation } from 'lib/cruises/cruiseUtils'
import PaletteProvider from 'contexts/PaletteProvider'
import PriceRowPriceCaption from 'components/Luxkit/PricePoints/PriceRowPriceCaption'
import PriceRowPrice from 'components/Luxkit/PricePoints/PriceRowPrice'
import PriceRowTaxesAndFees from 'components/Luxkit/PricePoints/PriceRowTaxesAndFees'

export const StyledExclamationIcon = styled(SolidExclamationCircleIcon)`
  position: relative;
  margin-left: ${rem(5)};
  top: ${rem(3)};
`

interface Props {
  offer: App.CruiseOffer;
  className?: string;
}

function HeroCruiseOfferTilePricing(props: Props) {
  const { offer } = props
  const { mainDepartureDetails } = offer
  const { lowestOverallPriceDetails } = mainDepartureDetails
  const { primaryPrice } = getCruiseOfferPriceVariation(offer, lowestOverallPriceDetails)
  const { discountPills } = lowestOverallPriceDetails

  return (
    <VerticalSpacer gap={8}>
      <Group direction="horizontal" horizontalAlign="space-between" verticalAlign="end">
        <div>
          <PriceRowPriceCaption>From</PriceRowPriceCaption>
          <PriceRowPrice
            size="L"
            price={primaryPrice.total}
            saleUnit={primaryPrice.type}
            taxesAndFees="inclusive"
          />
          <PriceRowTaxesAndFees taxesAndFees="inclusive" />
          <Caption variant="large" colour="neutral-three">Twin Share</Caption>
          {discountPills?.price && discountPills?.discountPercentage && (
            <ValueWrapper variant="large" weight="bold" colour="neutral-one">
              Valued up to <FormatCurrency value={discountPills.price}/>
              <PaletteProvider type="default">
                <Pill kind="primary" variant="success">
                  -{discountPills.discountPercentage}%
                </Pill>
              </PaletteProvider>
              <CruiseDiscountTermsAndConditions />
            </ValueWrapper>
          )}
        </div>
        <CSSBreakpoint min="desktop">
          <TextButton kind="primary" nonInteractable>
            View
          </TextButton>
        </CSSBreakpoint>
      </Group>
    </VerticalSpacer>
  )
}

export default HeroCruiseOfferTilePricing
